<template>
  <div id="Tab5">
    <!-- Referral Information -->
    <div class="tag-badge-info">
      <span class="tag-badge-title-info pb-2 pl-3">
        V. Uso Previo de Asistencia Tecnológica
      </span>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3" />

    <div class="additional-questions-item">
      <strong class="mx-3">¿Fue evaluado en AT?</strong>
      <div class="d-inline-flex">
        <div class="input-group mb-3">
          <input
            id="radEvaluatedYes"
            v-model="info.isEvaluatedFlag"
            type="radio"
            class="hidden"
            name="radEvaluated"
            :value="true"
            @click="rbtnEvaluatedChange(true, $event)"
          />
          <label class="entry" for="radEvaluatedYes">
            <div class="circle" />
            <div class="entry-label">Si</div>
          </label>

          <input
            id="radEvaluatedNo"
            v-model="info.isEvaluatedFlag"
            type="radio"
            class="hidden"
            name="radEvaluated"
            :value="false"
            @click="rbtnEvaluatedChange(false, $event)"
          />
          <label class="entry" for="radEvaluatedNo">
            <div class="circle" />
            <div class="entry-label">No</div>
          </label>
          <div class="highlight" />
        </div>
      </div>
    </div>

    <!-- The needs assessed in AT -->
    <div v-if="info.isEvaluatedFlag">
      <div class="form-group pb-2 ml-3">
        <div>
          <ValidationProvider
            v-slot="{ errors, invalid }"
            :rules="
              `${
                ValidationTriggered.validation && info.isEvaluatedFlag
                  ? 'required'
                  : ''
              }`
            "
            immediate
            name=" "
          >
            <CustomTextArea
              id="needsComments"
              v-model="info.needsComments"
              label="Las necesidades evaluadas en AT:"
              :maxlength="maxchars"
              :classes="['eq-field']"
              :disabled="atCompletedFlag"
              :invalid="invalid"
              :error="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
      <!-- Indicate other AT services -->

      <div class="form-group pb-2 ml-3">
        <div>
          <ValidationProvider
            v-slot="{ errors, invalid }"
            :rules="
              `${
                ValidationTriggered.validation && info.isEvaluatedFlag
                  ? 'required'
                  : ''
              }`
            "
            immediate
            name=" "
          >
            <CustomTextArea
              id="othersServicesProvider"
              v-model="info.othersServicesProvider"
              label="Indique otros servicios de AT que se le hayan provisto al estudiante especifique:"
              :maxlength="maxchars"
              :classes="['eq-field']"
              :disabled="atCompletedFlag"
              :invalid="invalid"
              :error="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
    </div>

    <div v-if="info.isEvaluatedFlag" class="additional-questions-item">
      <strong class="mx-3">¿El estudiante cuenta con equipo de AT?</strong>
      <div class="d-inline-flex">
        <div class="input-group mb-3">
          <input
            id="rbtnEquipmentYes"
            v-model="info.studentWithEquipmentFlag"
            type="radio"
            class="hidden"
            name="rbtnEquipment"
            :disabled="atCompletedFlag"
            :value="true"
            @click="studentWithEquipmentFlagChange(true, $event)"
          />
          <label class="entry" for="rbtnEquipmentYes">
            <div class="circle" />
            <div class="entry-label">Si</div>
          </label>

          <input
            id="rbtnEquipmentNo"
            v-model="info.studentWithEquipmentFlag"
            type="radio"
            class="hidden"
            name="rbtnEquipment"
            :disabled="atCompletedFlag"
            :value="false"
            @click="studentWithEquipmentFlagChange(false, $event)"
          />
          <label class="entry" for="rbtnEquipmentNo">
            <div class="circle" />
            <div class="entry-label">No</div>
          </label>
          <div class="highlight" />
        </div>
      </div>
    </div>
    <span class="text-danger">
      {{ hasEquipments() ? '' : 'Debe contener al menos un equipo' }}
    </span>
    <!-- Table -->
    <div v-if="info.studentWithEquipmentFlag" class="container-table-striped">
      <div class="table-hover">
        <table class="table content-table-striped table-striped mb-5">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-4 pl-5 py-3">
                <span class="ml-1 bold">Equipo programa de AT</span>
              </th>
              <th class="col-6 py-3 bold">
                Utilización / Satisfacción
              </th>
              <th class="col-2 pl-5 py-3">
                <span class="d-flex text-center" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in info.peiAtUsePreviousEquipments"
              :key="index"
              class="row"
            >
              <td class="col-4 pl-5 py-3">
                <span>
                  <b>{{ item.equipmentName }}</b>
                  <br />
                  Fecha:
                  <span style="text-transform: capitalize;">
                    {{ dateFormat(item.fromDate) }}
                  </span>
                </span>
              </td>
              <td class="col-6 py-3">
                <span>
                  ¿Utiliza el equipo programa de AT regularmente?
                  <b v-if="item.frequencyEquipment === 1">Si</b>
                  <b v-if="item.frequencyEquipment === 2">A veces</b>
                  <b v-if="item.frequencyEquipment === 3">No</b>
                  <span
                    v-if="item.frequencyEquipment != 1"
                    :data-tooltip="item.reason"
                  >
                    <i class="fas fa-info-circle text-green fa-xs pl-2" />
                  </span>
                  <br />
                  ¿Satisface adecuadamente la necesidad para su desempeño
                  escolar?
                  <b v-if="item.performaceSchool === 1">Si</b>
                  <b v-if="item.performaceSchool === 2">Parcialmente</b>
                  <b v-if="item.performaceSchool === 3">No</b>
                  <span
                    v-if="item.performaceSchool != 1"
                    :data-tooltip="item.explanation"
                  >
                    <i class="fas fa-info-circle text-green fa-xs pl-2" />
                  </span>
                </span>
              </td>
              <td class="col-2 dropdown py-3 pl-5">
                <button
                  v-if="!atCompletedFlag"
                  class="btn btn-dropdown-actions dropdown-toggle pt-1 ml-3"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu my-1">
                  <a class="drop-item" @click="editEquipment(item, index)">
                    <i class="fas fa-pencil-alt text-green pr-1" />
                    <span>{{ atCompletedFlag ? 'Leer' : 'Editar' }}</span>
                  </a>

                  <a
                    v-show="!atCompletedFlag"
                    class="drop-item"
                    @click="deleteEquipment(index)"
                  >
                    <i class="fas fa-times-circle text-red pr-1" />
                    <span>Eliminar</span>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <div v-if="info.studentWithEquipmentFlag" class="col-12 text-center">
            <button
              v-show="!atCompletedFlag && !ShowAddEquipment"
              class="btn bg-light-white w-50 pt-1 mt-4 button-add"
              @click="addNewEquipment(true)"
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document pt-4">
                Presione aquí para añadir Equipo AT
              </span>
            </button>
          </div>
        </table>
        <div v-if="ShowAddEquipment">
          <div class="tag-badgeNeed ml-2 pb-3 mb-3">
            <span class="dotNeed text-center pt-1">
              <i class="fas fa-plus orange-icon" />
            </span>
            <span
              class="tag-badge-titleNeed pb-2 pt-md-2 pt-xl-0 mb-0 pl-2 text-center"
            >
              Añadir Equipo / Programa
            </span>
          </div>
          <div class=" bg-rectangle-gradiant" />
          <div class="container-fluid bg-gray">
            <ValidationObserver ref="formValidator">
              <form novalidate @submit.prevent="saveEquipment">
                <div class="row d-flex justify-content-between">
                    <div class="form-group col-4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="equipo"
                    >
                       <custom-drop-down
                          v-model="equipment.serviceRecommendation"
                          :options="equipmentsAvailables"
                          placeholder="Seleccione"
                          required
                          :fieldkey="'id'"
                          :fieldname="'equipmentName'"                          
                          label="Equipo:"
                          :error="errors[0]"
                          custom-error-msg="Por favor seleccione un equipo." 
                          @input="onEquipmentChange($event)"                         
                        />
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-4" v-if="isOtherEquipmentOption">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="otherEquipment"
                    >
                      <CustomInput
                        ref="personInChargeName"
                        v-model="equipment.equipmentName"
                        label="Otro:"
                        type="text"
                        required
                        :error="errors[0]"
                        custom-error-msg="El nombre del equipo es requerido."
                      />
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name=" "
                    >
                      <CustomDatePicker
                        v-model="equipment.fromDate"
                        label="Desde:"
                        required
                        format="dd/MMM./yyyy"
                        :disabled="atCompletedFlag"
                        :error="errors[0]"
                        :custom-error-msg.sync="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                </div>

                <div class="additional-questions-item">
                  <strong class="mx-2">
                    ¿Utiliza el equipo programa de AT regularmente?
                  </strong>
                  <br />
                  <div class="d-flex flex-column ml-3">
                    <div class="d-inline-flex w-100">
                      <div class="input-group">
                        <div class="w-auto mr-3 w-25">
                          <div class="custom-control custom-radio">
                            <input
                              id="radUtilAt1"
                              v-model="equipment.frequencyEquipment"
                              type="radio"
                              class="custom-control-input"
                              name="radUtilAt"
                              :disabled="atCompletedFlag"
                              :value="1"
                              @click="frequencyEquipmentChange(1, $event)"
                            />
                            <label
                              class="custom-control-label fw-normal"
                              for="radUtilAt1"
                            >
                              Si, lo utiliza regularmente
                            </label>
                          </div>
                        </div>
                        <div class="w-auto mr-3 w-25">
                          <div class="custom-control custom-radio">
                            <input
                              id="radUtilAt2"
                              v-model="equipment.frequencyEquipment"
                              type="radio"
                              class="custom-control-input"
                              name="radUtilAt"
                              :disabled="atCompletedFlag"
                              :value="2"
                              @click="frequencyEquipmentChange(2, $event)"
                            />
                            <label
                              class="custom-control-label fw-normal"
                              for="radUtilAt2"
                            >
                              A veces lo utiliza
                            </label>
                          </div>
                        </div>
                        <div class="w-auto mr-3 w-25">
                          <div class="custom-control custom-radio">
                            <input
                              id="radUtilAt3"
                              v-model="equipment.frequencyEquipment"
                              type="radio"
                              class="custom-control-input"
                              name="radUtilAt"
                              :disabled="atCompletedFlag"
                              :value="3"
                              @click="frequencyEquipmentChange(3, $event)"
                            />
                            <label
                              class="custom-control-label fw-normal"
                              for="radUtilAt3"
                            >
                              No lo utiliza
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <Error
                        v-if="customErrorMsgFrequencyEquimpent != ''"
                        variant="no-border p-0"
                        :message="customErrorMsgFrequencyEquimpent"
                      />
                    </div>
                  </div>
                </div>
                <br />

                <div
                  v-if="
                    equipment.frequencyEquipment === 2 ||
                      equipment.frequencyEquipment === 3
                  "
                  style="width:100%"
                  class="row"
                >
                  <div class="form-group w-100 mx-4 mt-2 pb-2">
                    <div>
                      <ValidationProvider
                        v-slot="{ errors }"
                        :rules="
                          `${
                            equipment.frequencyEquipment === 2 ||
                            equipment.frequencyEquipment === 3
                              ? 'required'
                              : ''
                          }`
                        "
                        name=" "
                      >
                        <CustomTextArea
                          id="reason"
                          v-model="equipment.reason"
                          label="Razón:"
                          :maxlength="maxchars"
                          :classes="['eq-field']"
                          :disabled="atCompletedFlag"
                          :error="errors[0]"
                          :custom-error-msg.sync="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <br />
                <div class="additional-questions-ite w-100">
                  <strong class="mx-2">
                    ¿Satisface adecuadamente la necesidad para su desempeño
                    escolar?
                  </strong>
                  <div class="d-inline-flex w-100">
                    <div class="d-flex flex-column ml-3">
                      <div class="input-group d-flex">
                        <div class="w-auto">
                          <div class="custom-control custom-radio">
                            <input
                              id="radSatisfyAtYes"
                              v-model="equipment.performaceSchool"
                              type="radio"
                              class="custom-control-input"
                              name="radSatisfyAt"
                              :disabled="atCompletedFlag"
                              :value="1"
                              @click="rbtnSatisfyAtChek(1, $event)"
                            />
                            <label
                              for="radSatisfyAtYes"
                              class="custom-control-label fw-normal"
                            >
                              Si
                            </label>
                          </div>
                        </div>

                        <div class="w-auto mx-4">
                          <div class="custom-control custom-radio">
                            <input
                              id="radSatisfyAtPartial"
                              v-model="equipment.performaceSchool"
                              type="radio"
                              class="custom-control-input"
                              name="radSatisfyAt"
                              :disabled="atCompletedFlag"
                              :value="2"
                              @click="rbtnSatisfyAtChek(2, $event)"
                            />
                            <label
                              for="radSatisfyAtPartial"
                              class="custom-control-label fw-normal"
                            >
                              Parcialmente
                            </label>
                          </div>
                        </div>

                        <div class="w-auto">
                          <div class="custom-control custom-radio">
                            <input
                              id="radSatisfyAtNo"
                              v-model="equipment.performaceSchool"
                              type="radio"
                              class="custom-control-input"
                              name="radSatisfyAt"
                              :disabled="atCompletedFlag"
                              :value="3"
                              @click="rbtnSatisfyAtChek(3, $event)"
                            />
                            <label
                              for="radSatisfyAtNo"
                              class="custom-control-label fw-normal"
                            >
                              No
                            </label>
                          </div>
                        </div>
                        <br />
                      </div>
                      <div>
                        <Error
                          v-if="customErrorMsgPerfomaceSchool != ''"
                          variant="no-border p-0"
                          :message="customErrorMsgPerfomaceSchool"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="
                    equipment.performaceSchool === 2 ||
                      equipment.performaceSchool === 3
                  "
                  style="width:100%"
                  class="row"
                >
                  <div class="form-group w-100 mx-4 mt-2 pb-2">
                    <div>
                      <ValidationProvider
                        v-slot="{ errors }"
                        :rules="
                          `${
                            equipment.performaceSchool === 2 ||
                            equipment.performaceSchool === 3
                              ? 'required'
                              : ''
                          }`
                        "
                        name=" "
                      >
                        <CustomTextArea
                          id="explanation"
                          v-model="equipment.explanation"
                          label="Explique:"
                          :maxlength="maxchars"
                          :classes="['eq-field']"
                          :disabled="atCompletedFlag"
                          :error="errors[0]"
                          :custom-error-msg.sync="errors[0]"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex flex-row justify-content-end w-100 pr-3 pb-4"
                >
                  <ActionButton
                    v-show="!atCompletedFlag"
                    id="btnCancel"
                    variant="outline-danger mr-2"
                    type="button"
                    i="fas fa-times-circle"
                    @click="addNewEquipment(false)"
                  >
                    Cancelar
                  </ActionButton>
                  <ActionButton
                    id="btnAdd"
                    variant="success"
                    type="submit"
                    i="fas fa-file-plus"
                  >
                    Añadir
                  </ActionButton>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/pei/parte-k.css"></style>
<script>
import store from '@/store/index';
import moment from 'moment';
import alert from '../../../mixin/alert.mixin';
import ActionButton from '../../common/ActionButton';
import CustomTextArea from '../../common/CustomTextArea';
import CustomInput from '@/components/common/CustomInput';
import resourcesService from '../../../services/resources.js';
import loading from '@/mixin/loading.mixin';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Error from '@/components/common/Error';
import { mapMutations } from 'vuex';
import CustomDropDown from "custom-drop-down";

const OTHER_EQUIPMENT = -1;

export default {
  name: 'Tab6',
  mixins: [loading, alert],
  components: {
    ActionButton,
    CustomTextArea,
    CustomDatePicker,
    CustomInput,
    ValidationProvider,
    ValidationObserver,
    Error,
    CustomDropDown
  },
  data: () => ({
    resources: [],
    info: {
      isEvaluatedFlag: false,
      studentWithEquipmentFlag: false,
      needsComments: '',
      equipmentsFromAT: [],
      othersServicesProvider: '',
      peiAtUsePreviousEquipments: [],
      peiId:
        store.getters.SelectedPei !== undefined ? store.getters.SelectedPei : 0,
    },
    ValidationTriggered: store.getters.getatValidationTriggered,
    equipment: {
      id: 0,
      peiAtUsePreviousId: 0,
      equipmentName: null,
      serviceRecommendation: null,
      fromDate: null,
      frequencyEquipment: null,
      reason: '',
      performaceSchool: null,
      explanation: '',
      createdDate: null,
      createdById: null,
    },
    ShowAddEquipment: false,
    maxchars: 3000,
    itemIndex: -1,
    peiAtServiceId: 0,
    customErrorMsgPerfomaceSchool: '',
    customErrorMsgFrequencyEquimpent: '',
  }),

  methods: {
    ...mapMutations(['setATSaveBtnDisable']),
    rbtnSatisfyAtChek(value, event) {
      let self = this;
      if (event.target.checked && value === 1) {
        self.equipment.explanation = '';
      }
      self.validateCustomErrorsSatisfy(value);
    },
    async rbtnEvaluatedChange(value, event) {
      let self = this;
      if (
        event.target.checked &&
        !value &&
        (self.info.needsComments.length !== 0 ||
          self.info.othersServicesProvider.length !== 0 ||
          self.info.peiAtUsePreviousEquipments.length > 0)
      ) {
        let response = await alert.methods.ShowCancelModal(
          self.resources.USP003,
          self.resources.USP001,
          self.resources.USP004,
          self.resources.USP005
        );
        if (response) {
          self.info.needsComments = '';
          self.info.othersServicesProvider = '';
          self.info.studentWithEquipmentFlag = false;
          self.info.peiAtUsePreviousEquipments = [];
          self.cleanDraftEquipment();
        } else {
          self.info.isEvaluatedFlag = true;
        }
      } else {
        self.info.studentWithEquipmentFlag = false;
      }
    },

    async cleanDraftEquipment(value) {
      this.equipment.id = 0;
      this.equipment.peiAtUsePreviousId = this.peiAtServiceId;
      this.equipment.equipmentName = '';
      this.equipment.frequencyEquipment = null;
      this.equipment.reason = '';
      this.equipment.performaceSchool = null;
      this.equipment.explanation = '';
      this.equipment.serviceRecommendation = null;
      this.equipment.fromDate = null;
      (this.equipment.createdDate = null), (this.equipment.createdById = null);
      this.ShowAddEquipment = value;
    },
    async studentWithEquipmentFlagChange(value, event) {
      let self = this;
      if (
        event.target.checked &&
        !value &&
        self.info.peiAtUsePreviousEquipments.length > 0
      ) {
        let response = await alert.methods.ShowCancelModal(
          self.resources.USP003,
          self.resources.USP001,
          self.resources.USP004,
          self.resources.USP005
        );
        if (response) {
          self.info.peiAtUsePreviousEquipments = [];
          self.cleanDraftEquipment(false);
        } else {
          self.info.studentWithEquipmentFlag = true;
        }
      } else {
        self.cleanDraftEquipment(false);
      }
    },
    async addNewEquipment(value) {
      let self = this;

      self.cleanDraftEquipment(value);
    },
    frequencyEquipmentChange(value, event) {
      let self = this;
      if (event.target.checked && value === 1) {
        self.equipment.reason = '';
      }
      self.validateCustomErrorsFrequencyEquipment(value);
    },

    getUsePrevious() {
      this.$ApiGet(
        `/api/atservice/getpreviousequipments?peiAtServiceId=${this.peiAtServiceId}`
      )
        .then((res) => {
          if (res && res.data != null && res.data != '') {
            this.info = res.data;
            this.info.equipmentsFromAT.push({
              id: -1,
              equipmentName: 'Otro'
            })

            if (res.data.id !== null) this.setATSaveBtnDisable(false);
          } else {
            this.setATSaveBtnDisable(false);
          }
        })
        .catch((err) => {
          this.response = err;
        });
    },
    date: function(date) {
      return moment(date).format('DD/MMM/YYYY');
    },
    dateFormat: function(date) {
      if (date) {
        return moment(date)
          .locale('es')
          .format('DD/MMM/YYYY');
      }

      return '';
    },
    async save() {
      let self = this;
      self.info.peiAtServiceId = this.PeiAtServiceId;

      await self
        .$ApiPost('/api/atservice/insertpreviousequipments', self.info)
        .then((res) => {
          self.ShowToast(
            self.resources['R03200110'],
            self.resources['R03200109'],
            'success'
          );
          self.info.id = res.data;
        })
        .catch((err) => {
          self.response = err;
        });
    },
    async validateCustomErrorsSatisfy(value) {
      let self = this;
      if (value != undefined) {
        self.customErrorMsgPerfomaceSchool = '';
        return true;
      } else {
        if (self.equipment.performaceSchool == null) {
          self.customErrorMsgPerfomaceSchool = 'Debe seleccionar una opción';
          return false;
        } else {
          self.customErrorMsgPerfomaceSchool = '';
          return true;
        }
      }
    },
    async validateCustomErrorsFrequencyEquipment(value) {
      let self = this;
      if (value != undefined) {
        self.customErrorMsgFrequencyEquimpent = '';
        return true;
      } else {
        if (self.equipment.frequencyEquipment == null) {
          self.customErrorMsgFrequencyEquimpent = 'Debe seleccionar una opción';
          return false;
        } else {
          self.customErrorMsgFrequencyEquimpent = '';
          return true;
        }
      }
    },
    async saveEquipment() {
      let self = this;
      const isFormValid = await self.$refs.formValidator.validate();

      const validateCustomErrorsSatisfy = await self.validateCustomErrorsSatisfy();
      const validateCustomErrorsFrequencyEquipment = await self.validateCustomErrorsFrequencyEquipment();
      if (
        isFormValid &&
        validateCustomErrorsSatisfy &&
        validateCustomErrorsFrequencyEquipment
      ) {
        let equipmentToAdd = Object.assign({}, self.equipment);
        equipmentToAdd.peiAtServiceRecommendationId = null;
        if(self.equipment.serviceRecommendation?.id != OTHER_EQUIPMENT)
        {
          equipmentToAdd.peiAtServiceRecommendationId = self.equipment.serviceRecommendation?.id
        }        
        if (self.itemIndex >= 0) {
          self.info.peiAtUsePreviousEquipments[this.itemIndex] = equipmentToAdd;
          self.itemIndex = -1;
        } else {          
          self.info.peiAtUsePreviousEquipments.push(equipmentToAdd);
        }
        self.cleanDraftEquipment(false);
      }
    },
    onEquipmentChange(equipment)
    {    
      this.equipment.fromDate = null;
      this.equipment.equipmentName = null;      
      if(equipment?.id != OTHER_EQUIPMENT)
      {
        this.equipment.fromDate = equipment.schoolDeliveryDate;
        this.equipment.equipmentName = equipment.equipmentName;
      }
    },    
    async deleteEquipment(indexToRemove) {
      let self = this;
      let response = await alert.methods.ShowCancelModal(
        self.resources.USP003,
        self.resources.USP001,
        self.resources.USP004,
        self.resources.USP005
      );
      if (response) {
        self.info.peiAtUsePreviousEquipments.splice(indexToRemove, 1);
      }
    },
    editEquipment(equipmentToEdit, index) {
      let self = this;    
      self.equipment = equipmentToEdit;
      self.ShowAddEquipment = true;
      this.itemIndex = index;
    },

    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'USP001',
        'USP002',
        'USP003',
        'USP004',
        'USP005',
        'R03200110',
        'R03200109',
      ]);
    },

    hasEquipments() {
      if (this.info.studentWithEquipmentFlag && this.atCompletedFlag) {
        return this.info.peiAtUsePreviousEquipments.length > 0;
      } else {
        return true;
      }
    },
    validateReadMode() {
      if (!this.atCompletedFlag) {
        return;
      }

      const tags = ['input', 'button', 'textarea', 'select'];
      tags.forEach((tagName) => {
        const nodes = document
          .getElementById('Tab5')
          .getElementsByTagName(tagName);

        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;

          if (tagName == 'button') {
            nodes[i].style.display = 'none';
          }
        }
      });
    },
  },
  mounted() {
    this.setATSaveBtnDisable(true);
    this.peiAtServiceId =
      store.getters.SelectedAt !== undefined ? store.getters.SelectedAt : 0;
    this.getUsePrevious();
    this.validateReadMode();
    this.loadResources();
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    PeiAtServiceId() {
      return store.getters.SelectedAt;
    },
    equipmentsAvailables(){      
      return this.info.equipmentsFromAT.filter(c=> this.info.peiAtUsePreviousEquipments.find(x=> x.peiAtServiceRecommendationId != -1 && x.peiAtServiceRecommendationId == c.id) == null);
    },
    isOtherEquipmentOption()
    {    
      return this.equipment.serviceRecommendation?.id == OTHER_EQUIPMENT
    }
  },
};
</script>

<style scoped>
@import '../../../assets/css/previousofat/tab5.css';

.active {
  border: 2px solid red;
}

.fw-normal {
  font-weight: normal;
}
</style>
